import { render, staticRenderFns } from "./indexnav.vue?vue&type=template&id=5f22d434&scoped=true"
import script from "./indexnav.vue?vue&type=script&lang=js"
export * from "./indexnav.vue?vue&type=script&lang=js"
import style0 from "./indexnav.vue?vue&type=style&index=0&id=5f22d434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22d434",
  null
  
)

export default component.exports